// named thanks to https://chir.ag/projects/name-that-color/
export const Color = {
  APRICOT_ORANGE: '#FFA573', // Pastel Orange
  ANAKIWA: '#91e3fa', // Pastel Blue 2
  BABY_BLUE: '#9bbefd', // Pastel Blue 1
  BLACK: '#000000',
  BLUE_BIG_STONE: '#1b2b3d',
  BLUE_CHATHAMS: '#13346d',
  BLUE_DODGER: '#2da3ff', // Twitter
  BLUE_RIBBON: '#005EFF',
  BLUE_RIBBON_EXTENDS: '#146aff0d',
  BLUE_SCIENCE: '#0049cb',
  BRILLIANT_ROSE: '#f35e9a',
  CARNATION: '#f05f6a',
  CARNATION_PINK: '#ffa9d0', // Pastel Pink 1
  CASABLANCA: '#f8be4a',
  CHAMBRAY: '#3B5998', // Facebook
  CHARM: '#ca6584',
  CRIMSON: '#D11553',
  CLEAR_BLUE_DODGER: '#32cdfb',
  CLOUD_BURST: '#1d254f',
  CORAL_RED: '#FF8686', // Pastel Red
  CORNFLOWER_BLUE: '#8258f3',
  CORNFLOWER_MAUVE: '#b198fb',
  CORNFLOWER_MAUVE_LIGHT: '#7187e9',
  DEEP_CERULEAN: '#007bb5', // LinkedIn
  DOLPHIN: '#656686',
  DUSTY_GREY: '#9b9b9b',
  ELECTRIC_VIOLET: '#8800ff',
  GHOST_WHITE: '#f6f7fb',
  GRANDIS: '#ffd77c', // Pastel Yellow
  GRAY_GALLERY: '#ebebeb',
  HEATHER: '#C2CBD6',
  LIME_GREEN: '#A9E58D', // Pastel Green 2
  LILAC_BUSH: '#907CCC',
  LILAC_PURPLE: '#E6AEFA', // Pastel Pink 2
  MEDIUM_RED_VIOLET: '#c32aa3', // Instragram
  MOUNTAIN_MEADOW: '#25d366', // Whatsapp
  MY_SIN: '#ffb522',
  MYSTIC: '#e7ebf0',
  PASTEL_GREEN: '#74e073',
  PERFUME: '#b397f5', // Pastel Purple
  PERSIAN_BLUE: '#4428d4',
  PURPLE_HEART: '#7035b4',
  RAZZMATAZZ: '#e4165c',
  RED: '#ff0000', // Youtube
  SAFFRON: '#f3b63f',
  SEAFOAM_GREEN: '#63D5B0', // Pastel Green 1
  SHAMROCK: '#5ae0a6',
  WATER_LINK: '#fbfcfe',
  WHISPER: '#f6f7fa',
  WHITE: '#ffffff',
  YELLOW: '#fffC00', // Snapchat
  YELLOW_SELECTIVE: '#ffb500',
  ZIRCON: '#f4f8ff',
  ZUMTHOR: '#ebf2ff',
};

export const Gradient = {
  FADE_BLUE: `linear-gradient(180deg, ${Color.BLUE_DODGER} 0%, ${Color.BLUE_RIBBON} 100%)`,
  FADE_PURPLE: `linear-gradient(180deg, ${Color.CORNFLOWER_MAUVE} 0%, ${Color.CORNFLOWER_MAUVE_LIGHT} 100%)`,
  FADE_SPACE: `linear-gradient(180deg, ${Color.CHARM} 0%, ${Color.PERSIAN_BLUE} 100%)`,
  FADE_GOLD: `linear-gradient(180deg, ${Color.GRANDIS} 0%, ${Color.MY_SIN} 100%)`,
  FADE_RED: `linear-gradient(180deg, ${Color.CARNATION} 0%, ${Color.RED} 100%)`,
  BORDER_BLUE: `linear-gradient(to bottom, ${Color.BLUE_DODGER}, ${Color.BLUE_RIBBON}) 1 100%`,
  FILTER_BLUE_RIGHT: `linear-gradient(150deg, transparent 50%, ${Color.BLUE_RIBBON} 90%);`,
  FILTER_BLUE_LEFT: `linear-gradient(210deg, transparent 50%, ${Color.BLUE_RIBBON} 90%);`,
  FILTER_PURPLE_RIGHT: `linear-gradient(150deg, transparent 50%, ${Color.CORNFLOWER_MAUVE} 90%)`,
  FILTER_PURPLE_LEFT: `linear-gradient(210deg, transparent 50%, ${Color.CORNFLOWER_MAUVE} 90%)`,
};
